import { useEffect } from 'react'
import { View } from 'react-native'
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated'
import { useTranslation } from 'react-i18next'
import Typography from '@ui/typography/Typography'

import { MeasurementMessage } from '../types'
import MessageIcon from './MessageIcon'

type Props = {
  message: MeasurementMessage
  active: MeasurementMessage | null
}

export default function MessageItem({ message, active }: Props) {
  const { t } = useTranslation(['measurement'])
  const tl = 'measurement:app.messages'
  const isActive = message === active
  const opacity = useSharedValue(isActive ? 1 : 0)

  const styleOpacity = useAnimatedStyle(() => ({
    opacity: opacity.value,
  }))

  useEffect(() => {
    opacity.set(withTiming(isActive ? 1 : 0))
  }, [isActive, opacity])

  return (
    <Animated.View
      className="absolute inset-0 flex flex-col items-center justify-start"
      style={[
        {
          paddingTop: 32,
          gap: 24,
        },
        styleOpacity,
      ]}
    >
      <View
        className="flex flex-col items-center justify-center"
        style={{
          width: 640,
          height: 64,
        }}
      >
        <Typography
          variant="MDB"
          className="flex w-full flex-col content-start items-center justify-start truncate text-center text-white"
          numberOfLines={2}
        >
          {t(`${tl}.${message}.text`)}
        </Typography>
      </View>
      <MessageIcon message={message} isActive={isActive} />
    </Animated.View>
  )
}
